import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/claims/task-lists/')({
    beforeLoad: ({ params }) => {
        throw redirect({
            to: '/console/$orgId/configuration/claims-products/claims/task-lists/search',
            params,
            replace: true,
        });
    },
});
